// ─── types.ts ────────────────────────────────────────────────────────────────

export interface ClassData {
  id: string;
  class_name: string;
  sections: string[];
}

export interface StudentData {
  id: number;
  user_id: number;
  name: string;
  gender: string;
  email_id: string;
  class_id: string;
  section: string | null;
  admission_no: string;
  roll_no: number;
  dob: string;
  blood_group: string;
  father_name: string;
  mother_name: string;
  father_no: string;
  mother_no: string;
  address: string;
  created_at: string;
  updated_at: string;
  user_email: string;
  profile_picture_url: string;
  class_name: string;
}

export interface UDISERow {
  [key: string]: string;
}

export interface FieldMapping {
  dbField: keyof StudentData | '';
  udiseField: string;
  label: string;
  enabled: boolean;
}

export type AnomalyType = 'mismatch' | 'missing_in_db' | 'missing_in_udise' | 'match';

export interface FieldAnomaly {
  dbField: string;
  udiseField: string;
  label: string;
  dbValue: string;
  udiseValue: string;
  type: AnomalyType;
}

export interface StudentAnomaly {
  dbStudent: StudentData | null;
  udiseRow: UDISERow | null;
  anomalies: FieldAnomaly[];
  matchKey: string;
  overallStatus: 'match' | 'anomaly' | 'missing_in_db' | 'missing_in_udise';
}

export type ModalView = 'none' | 'class_mapping' | 'field_mapping' | 'results';

// ─── Shared constants ─────────────────────────────────────────────────────────

export const DB_FIELDS: { key: keyof StudentData; label: string }[] = [
  { key: 'name',         label: 'Full Name'      },
  { key: 'gender',       label: 'Gender'         },
  { key: 'dob',          label: 'Date of Birth'  },
  { key: 'father_name',  label: "Father's Name"  },
  { key: 'mother_name',  label: "Mother's Name"  },
  { key: 'admission_no', label: 'Admission No'   },
  { key: 'roll_no',      label: 'Roll No'        },
  { key: 'class_name',   label: 'Class'          },
  { key: 'section',      label: 'Section'        },
  { key: 'blood_group',  label: 'Blood Group'    },
  { key: 'address',      label: 'Address'        },
  { key: 'email_id',     label: 'Email'          },
  { key: 'father_no',    label: "Father's No"    },
  { key: 'mother_no',    label: "Mother's No"    },
];

export const DEFAULT_MAPPINGS: FieldMapping[] = [
  { dbField: 'name',        udiseField: 'Name',        label: 'Full Name',     enabled: true },
  { dbField: 'gender',      udiseField: 'Gender',      label: 'Gender',        enabled: true },
  { dbField: 'father_name', udiseField: 'Father Name', label: "Father's Name", enabled: true },
  { dbField: 'mother_name', udiseField: 'Mother Name', label: "Mother's Name", enabled: true },
];

export const STATUS_CONFIG = {
  match:            { color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0', icon: 'pi pi-check-circle',       label: 'Match'        },
  anomaly:          { color: '#dc2626', bg: '#fef2f2', border: '#fecaca', icon: 'pi pi-exclamation-circle', label: 'Anomaly'      },
  missing_in_db:    { color: '#1d4ed8', bg: '#eff6ff', border: '#bfdbfe', icon: 'pi pi-user-minus',         label: 'Not in DB'    },
  missing_in_udise: { color: '#ea580c', bg: '#fff7ed', border: '#fed7aa', icon: 'pi pi-file-excel',         label: 'Not in UDISE' },
} as const;

// Shared select style used across modals
export const sel: React.CSSProperties = {
  width: '100%', padding: '8px 10px', borderRadius: 10,
  border: '1.5px solid #dbeafe', background: 'white',
  fontSize: 13, color: '#1e3a8a', outline: 'none', cursor: 'pointer',
};